<template>
    <div id="toast">
        <transition name="toast-fade">
            <div
                v-show="visible"
                class="toast"
                :class="['toast--' + type]"
                @mouseleave="start"
                @mouseenter="stop"
            >
                <i :class="icon" class="toast__icon"></i>
                <div class="toast__message">{{ message }}</div>
                <i
                    v-if="showCloseBtn"
                    class="el-icon-close toast__close hand-style"
                    @click="close"
                ></i>
            </div>
        </transition>
    </div>
</template>

<script>
const TYPE_CONFIG = {
    success: { icon: 'iconfont icon-chenggong' },
    error:   { icon: 'iconfont icon-cuo' },
    warning: { icon: 'iconfont icon-jinggao1' },
    info:    { icon: 'iconfont icon-jinggao1' },
    normal:  { icon: 'iconfont icon-jinggao1' }
}

// request.js reject 出来的哨兵文案：登录失效由登录框提示，封禁由封禁弹窗提示，
// 调用方直接 toast(err.message) 时不能把它们原样显示出来
const SILENT_MESSAGES = ['__SILENT_AUTH__', '__ACCOUNT_BANNED__']

export default {
    name: 'Toast',
    data () {
        return {
            visible: false,
            message: '',
            icon: '',
            type: 'normal',
            timer: null,
            showCloseBtn: false
        }
    },
    methods: {
        close () {
            this.visible = false
            this.clearTimer()
        },
        stop () {
            this.clearTimer()
        },
        start () {
            this.clearTimer()
            this.timer = setTimeout(() => {
                this.visible = false
            }, 3000)
        },
        clearTimer () {
            if (this.timer) {
                clearTimeout(this.timer)
                this.timer = null
            }
        },
        after (message) {
            if (!message || SILENT_MESSAGES.indexOf(message) !== -1) return
            this.message = message
            this.visible = true
            this.start()
        },
        applyType (type) {
            this.type = type
            this.icon = (TYPE_CONFIG[type] || TYPE_CONFIG.normal).icon
        },
        show (option = {}) {
            if (!option.message || SILENT_MESSAGES.indexOf(option.message) !== -1) return
            this.applyType(option.type || 'normal')
            this.showCloseBtn = !!option.showClose
            this.after(option.message)
        },
        success (message) {
            this.showCloseBtn = false
            this.applyType('success')
            this.after(message)
        },
        error (message) {
            this.showCloseBtn = false
            this.applyType('error')
            this.after(message)
        },
        warning (message) {
            this.showCloseBtn = false
            this.applyType('warning')
            this.after(message)
        },
        // 兼容旧的拼写
        warnning (message) {
            this.warning(message)
        },
        fail (message) {
            this.error(message)
        },
        info (message) {
            this.showCloseBtn = false
            this.applyType('info')
            this.after(message)
        }
    }
}
</script>

<style lang="scss" scoped>
.toast {
    position: fixed;
    top: 24px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 99999;
    display: flex;
    align-items: center;
    max-width: min(420px, calc(100vw - 32px));
    padding: 10px 16px;
    border-radius: 8px;
    border: 1px solid transparent;
    background: #fff;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08), 0 3px 6px rgba(0, 0, 0, 0.04);
    color: #303133;
    font-size: 14px;
    line-height: 1.5;

    .toast__icon {
        flex-shrink: 0;
        margin-right: 8px;
        font-size: 18px;
        line-height: 1;
    }

    .toast__message {
        flex: 1;
        word-break: break-word;
    }

    .toast__close {
        flex-shrink: 0;
        margin-left: 12px;
        font-size: 14px;
        color: #909399;
        cursor: pointer;
        transition: color 0.2s;

        &:hover {
            color: #606266;
        }
    }

    &.toast--success {
        background: #f0f9eb;
        border-color: #e1f3d8;
        color: #67c23a;
        .toast__icon { color: #67c23a; }
    }

    &.toast--error {
        background: #fef0f0;
        border-color: #fde2e2;
        color: #f56c6c;
        .toast__icon { color: #f56c6c; }
    }

    &.toast--warning {
        background: #fdf6ec;
        border-color: #faecd8;
        color: #e6a23c;
        .toast__icon { color: #e6a23c; }
    }

    &.toast--info {
        background: #f4f4f5;
        border-color: #e9e9eb;
        color: #909399;
        .toast__icon { color: #909399; }
    }

    &.toast--normal {
        background: #ecf5ff;
        border-color: #d9ecff;
        color: #409eff;
        .toast__icon { color: #409eff; }
    }
}

.toast-fade-enter-active,
.toast-fade-leave-active {
    transition: opacity 0.25s ease, transform 0.25s ease;
}

.toast-fade-enter,
.toast-fade-leave-to {
    opacity: 0;
    transform: translate(-50%, -12px);
}
</style>
